import { render, staticRenderFns } from "./DoctorRegisterRecordSettle.vue?vue&type=template&id=6d9fc7f8&scoped=true&"
import script from "./DoctorRegisterRecordSettle.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterRecordSettle.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterRecordSettle.vue?vue&type=style&index=0&id=6d9fc7f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9fc7f8",
  null
  
)

export default component.exports